// GENERATED from ez-tree preset "Aspen Medium" — Scripts/EzTree/PresetConverter.js
// Rerun (to see the drift vs. upstream ez-tree): npm start client.eztree.convertPresets
// NOT read-only: hand tweaks are expected; the converter is just the starting point.
//
// Sizing: targetHeight (metres) is THE scale knob — the generator scales the mesh uniformly to
// that height (unset = the root's default). value = rawHeight × ezTreeUnitToMeters, so the preset
// keeps its natural proportions (× 1.1 on value = +10% overall size); `swing` varies the height
// ±its fraction across the kind's variants. Both numbers are meant to be hand-tweaked.
// footprintRadiusRatio = observed width / observed height; resolved footprint radius =
// targetHeight × footprintRadiusRatio (so resizing via targetHeight keeps width proportional).
import {SceneryKindDef} from "../../@SceneryTypes.js";
import {EZTREE_ROOT_KIND_ID} from "../Kind_EzTree.js";

export const AspenMedium_KIND_ID = "ezTree_AspenMedium";

export const AspenMediumKind = new SceneryKindDef({
	id: "ezTree_AspenMedium",
	name: "Aspen Medium",
	baseKindID: EZTREE_ROOT_KIND_ID,
	// Only the flat keys differing from the root's defaults (TreeOptions ctor defaults) are set —
	// everything else inherits the root.
	paramOverrides: {
		"branchLevels": 2,
		"branchAngle1": 75,
		"branchAngle2": 32,
		"branchAngle3": 7,
		"branchChildren0": 10,
		"branchChildren1": 3,
		"branchChildren2": 3,
		"branchGnarliness0": 0.05,
		"branchGnarliness1": 0.12,
		"branchGnarliness2": 0.12,
		"branchLength0": 50,
		"branchLength1": 6.07,
		"branchLength2": 11.19,
		"branchRadius0": 0.72,
		"branchRadius1": 0.41,
		"branchStart1": 0.59,
		"branchStart2": 0.35,
		"branchStart3": 0,
		"branchTaper0": 0.37,
		"branchTaper1": 0.13,
		"leafCount": 11,
		"leafAngle": 30,
		"leafStart": 0.124,
		"leafType": "aspen",
		"barkType": "Bark002",
		"forceStrength": 0.0148,
		"targetHeight": 17.33,
	},
	footprintRadiusRatio: 0.259,
});
